// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import OurProgramsPage from "../pages/OurPrograms/OurPrograms";
const __wvcRoutePaths = ["/OurProgramsPage", "/nos-programmes"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["a-propos", "aboutpage", "accueil", "becomememberpage", "devenir-membre", "donatepage", "faire-un-don", "galerie", "gallerypage", "homepage", "infolettre", "inscription-des-benevoles", "joinuspage", "memoires-vives-en-partage", "memoiresvivespage", "newsletterpage", "nos-evenements", "nos-programmes", "nosactivites", "nous-rejoindre", "ouractivitiespage", "oureventspage", "ourprogramspage", "post", "volunteerregistrationpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<OurProgramsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<OurProgramsPage />} />
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
